import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import axios from "axios"
import { PageSEO } from "@/components/page-seo"
import { JitsiEmbed } from "@/components/telehealth/JitsiEmbed"
import { API_BASE } from "@/config/api"

const API = API_BASE

export default function PatientVideoCall() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const token = params.get("token") || ""
  const appointmentId = params.get("appointment_id") || ""
  const [session, setSession] = useState(null)
  const [err, setErr] = useState("")

  useEffect(() => {
    if (!token || !appointmentId) {
      setErr(t("public.patientPortal.missingToken"))
      return
    }
    axios
      .get(`${API}/public/telehealth/session`, { params: { token, appointment_id: appointmentId } })
      .then((r) => setSession(r.data))
      .catch(() => setErr(t("public.telehealth.unavailable")))
  }, [token, appointmentId, t])

  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background">
        <PageSEO seoKey="patientPortal" />
        <p className="text-destructive text-sm">{err}</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <PageSEO seoKey="patientPortal" />
      <header className="p-4 border-b border-border">
        <h1 className="font-display text-lg tracking-tight font-medium">
          {t("public.telehealth.title")}
        </h1>
        {session?.client_name && (
          <p className="text-xs text-muted-foreground mt-1">{session.client_name}</p>
        )}
      </header>
      <div className="flex-1 min-h-0">
        {session ? (
          <JitsiEmbed
            domain={session.domain}
            roomName={session.room_name}
            jwt={session.jwt}
            displayName={session.client_name || "Pacient"}
          />
        ) : (
          <p className="p-6 text-sm text-muted-foreground">{t("public.patientPortal.loading")}</p>
        )}
      </div>
    </div>
  )
}
